import { Box, Typography } from '@mui/material';

export const TopSection = ({
    numberOfContacts,
    prospectCollectionName,
}: {
    numberOfContacts: number;
    prospectCollectionName: string;
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                alignSelf: 'stretch',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    gap: 'var(--S-2xs, 4px)',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 'var(--S-s-regular, 8px)',
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontSize: '24px',
                            lineHeight: '36px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            maxWidth: '500px',
                        }}
                    >
                        {prospectCollectionName}
                    </Typography>
                </Box>
                {numberOfContacts && <Typography variant="subtitle2">{numberOfContacts} contacts</Typography>}
            </Box>
        </Box>
    );
};
